// https://docs.aws.amazon.com/sdk-for-javascript/v3/developer-guide/getting-started.html
import {
  SecretsManagerClient,
  GetSecretValueCommand
} from '@aws-sdk/client-secrets-manager';
import CryptoJS from 'crypto-js';
import { CRYPTOJS_UUID_SECRET } from '../apiRoutes';

export async function secretsHelper() {
  const secretsClient = new SecretsManagerClient({
    region: 'us-east-1'
  });

  const secret_name = 'dev/notaavulsa/secretapi';

  try {
    const response = await secretsClient.send(
      new GetSecretValueCommand({
        SecretId: secret_name,
        VersionStage: 'AWSCURRENT'
      })
    );
    if (response.SecretString) {
      return JSON.parse(response.SecretString);
    }
    throw new Error('Secret not found in SecretString format.');
  } catch (error) {
    console.error('Erro ao obter o segredo:', error);
    throw error;
  }
}

// 1
export function cript(value) {
  const encrypted = CryptoJS.AES.encrypt(
    value,
    CryptoJS.enc.Utf8.parse(CRYPTOJS_UUID_SECRET),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

// 2
export function deCript(base64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(base64) },
    CryptoJS.enc.Utf8.parse(CRYPTOJS_UUID_SECRET),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

// 3
export function asUuid(id) {
  if (id == null) return null;

  const encrypted = cript(id.toString());
  const buffer = CryptoJS.enc.Base64.parse(encrypted).toString(
    CryptoJS.enc.Hex
  );

  const b = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    b[i] = parseInt(buffer.substr(i * 2, 2), 16);
  }

  const hex = buffer.substr(0, 32);

  return {
    uuid: `${hex.substr(0, 8)}-${hex.substr(8, 4)}-${hex.substr(
      12,
      4
    )}-${hex.substr(16, 4)}-${hex.substr(20, 12)}`,
    buffer: b
  };
}

// ...
export const parseUuidStringToBuffer = (uuidString) => {
  const hex = uuidString.replace(/-/g, '');
  const buffer = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    buffer[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return buffer;
};

// 4
export function asLong(uuidBuffer) {
  if (!uuidBuffer) return null;

  const base64 = CryptoJS.enc.Base64.stringify(
    CryptoJS.lib.WordArray.create(uuidBuffer)
  );
  const decrypted = deCript(base64);
  return parseInt(decrypted, 10);
}
